import { colors } from '@ui';

import { MARKER_RADIUS } from '../consts';

type SVGMarkProps = {
    isOpen: boolean;
    numberOfThreads: number;
    onClick: () => void;
};

export const SVGMark = ({ isOpen, numberOfThreads, onClick }: SVGMarkProps) => (
    <svg>
        <line
            style={{ pointerEvents: 'none' }}
            x1={0}
            x2={0}
            y1={0}
            y2={MARKER_RADIUS}
            stroke={colors.teal[400]}
            strokeLinecap="round"
            strokeWidth={MARKER_RADIUS / 2}
        />
        <g style={{ cursor: 'pointer', pointerEvents: 'all' }} onClick={onClick}>
            <circle cx={0} cy={-0.5 * MARKER_RADIUS} r={MARKER_RADIUS} fill={colors.teal[400]} strokeWidth={0} />
            {isOpen && (
                <circle cx={0} cy={-0.5 * MARKER_RADIUS} r={MARKER_RADIUS * 0.8} fill={colors.white} strokeWidth={0} />
            )}
            {isOpen && (
                <circle
                    cx={0}
                    cy={-0.5 * MARKER_RADIUS}
                    r={MARKER_RADIUS * 0.7}
                    fill={colors.teal[700]}
                    strokeWidth={0}
                />
            )}
            {numberOfThreads > 1 && (
                <text
                    stroke="none"
                    fontWeight={700}
                    fill={isOpen ? colors.white : colors.bluegray[600]}
                    textAnchor="middle"
                    fontSize={12}
                    y={-2}
                >
                    {numberOfThreads > 9 && (
                        <tspan x={-1} fontSize={10}>
                            +
                        </tspan>
                    )}
                    <tspan>{numberOfThreads > 9 ? 9 : numberOfThreads}</tspan>
                </text>
            )}
        </g>
    </svg>
);
